import DownloadGlobalScenario from "./DownloadGlobalScenario"
import CreateEditGlobalScenario from "./CreateEditGlobalScenario"
import ManageGlobalScenario from "./ManageGlobalScenario"
import BasicCard from "../../../components/basics/cards/BasicCard"
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'

function GlobalScenario() {
    return (
        <BasicCard cardConfig={{ cardTitle: 'Global scenario administration', cardHeadingElement: 'h4' }}>
            <Tabs defaultActiveKey='download' id='global-scenario-tabs' className='mb-3'>
                <Tab eventKey='download' title='Download global scenario'>
                    <DownloadGlobalScenario />
                </Tab>
                <Tab eventKey='add-edit' title='Create/Edit global scenario'>
                    <CreateEditGlobalScenario />
                </Tab>
                <Tab eventKey='manage' title='Manage global scenario'>
                    <ManageGlobalScenario />
                </Tab>
            </Tabs>
        </BasicCard>
    )
}

export default GlobalScenario